import { Component, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

//Services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from 'src/app/core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HiringService } from '../../../pages/hiring/services/hiring.service';
import { HomeService } from 'src/app/pages/home/services/home.service';

//Modals
import { AddressConfirmationModalComponent } from '../../employee/personal-info/address-confirmation-modal/address-confirmation-modal.component';

@Component({
  selector: 'app-review-w4-modal',
  templateUrl: './review-w4-modal.component.html',
  styleUrls: ['./review-w4-modal.component.css']
})

export class ReviewW4ModalComponent implements OnInit {

  @ViewChild('W4Form', { static: false }) W4Form: NgForm;
  @ViewChild('signaturePad', { static: false }) signaturePad;
  @Input() id: number;
  @Input() viewMode: boolean;
  portalSettings: any;
  employeeInfo: any;
  format: string;
  mobileMode: boolean = false;
  currencyFormatSymbols: any;
  currencySymbol: string;
  currentYear: number;
  formData: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; adaptivePosition: boolean };
  alreadySubmitted: boolean = false;
  stateList: any[];
  submitSignImg: string;
  validateCheck: boolean = false;
  alert: string;
  isAddressValidationEnabled: boolean = false;
  enableCheckboxSign: boolean = false;
  latitude: any;
  longitude: any;
  signatureNEmpty: boolean = false;
  rawImgData: any;
  hideClick: boolean = false;
  showClickMsg: boolean = false;
  redBorder: boolean = false;
  fillW4: boolean = false;
  fillW4URL: string = "/careers/fillw4";
  tasksURL: string = "/careers/tasks"
  signaturePadOptions: Object = {
    'canvasWidth': 470,
    'canvasHeight': 150
  }

  constructor(portalSettingsService: PortalSettingsService, @Optional() employeeInfoService: EmployeeInfoService, private utilityService: UtilityService, private hiringService: HiringService, @Optional() private activeModal: NgbActiveModal, private homeService: HomeService, private modalService: NgbModal, private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.mobileMode = this.utilityService.isMobileMode();
    this.format = this.utilityService.getDateFormat() 
    this.isAddressValidationEnabled = this.portalSettings.IsAddressValidated.ConfigValue == "1";   
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == "1";
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, adaptivePosition: true };
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo?.PRCo);
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
    this.currentYear = new Date().getFullYear();
    this.formData.IsExempt = false;
    this.formData.SignDate = new Date(moment().format("MM/DD/YYYY"));

    if (parseInt(new Date().toString()) < parseInt(new Date("2020/01/01").toString()))
      this.formData.showNewForm = false;
    else
      this.formData.showNewForm = true;

    this.getRouteData();

    if (this.fillW4) {
      this.getInfoByOnboardID();
    }

    this.getDependentLookupByColumnName();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }

    if (this.fillW4) {
      this.getW4Info(1);
    } else {
      this.getW4Info(2);
    }

  }

  getRouteData() {
    var path = window.location.pathname;
    if (path != null && path.length > 1) {
      if (path == this.fillW4URL.toLowerCase()) {
        this.fillW4 = true;
      } else {
        this.alreadySubmitted = true;
      }
    }
  }

  getDependentLookupByColumnName() {
    this.hiringService.getDependentLookupByColumnName("State", null).then((response: any[]) => {
      if (response != null) {
        this.stateList = response;
      }
    });
  }

  getInfoByOnboardID() {
    this.hiringService.getInfoByOnboardID().then((response: any) => {
      if (response != null && response.DateSubmitted != null)
        this.alreadySubmitted = true;
      else
        this.alreadySubmitted = false;
    });
  }


  switchLanguage() {
    if (this.formData.FormLanguage == "EN")
      this.formData.FormLanguage = "ES";
    else
      this.formData.FormLanguage = "EN";
  }

  getW4Info(step: number) {
    this.hiringService.getW4Info(this.id, step).then((response: any) => {
      if (response != null && response.length > 0) {
        var w4Info = response[0];
        for (let key in w4Info) {
          if (key == "IsDiffLastName") {
            if (w4Info[key] != null) {
              this.formData.IsDiffLastName = w4Info[key];
            }
          }
          else if (key == "IsExempt") {
            if (w4Info[key] != null) {
              this.formData.IsExempt = w4Info[key];
            }
          }
          else if (key == "SignDate") {
            if (w4Info[key] != null) {
              this.formData.SignDate = new Date(moment(w4Info[key], this.format.toUpperCase()).utc().format("MM/DD/YYYY"));
            }
          }
          else if (key == "SignatureBinary" && this.alreadySubmitted) {
            if (w4Info[key] != null) {
              this.submitSignImg = "data:image/png;base64," + this.base64ArrayBuffer(w4Info[key]);
            }
          }
          else if (key == "DateFirstEmployment") {
            if (w4Info[key] != null) {
              this.formData.DateFirstEmployment = new Date(moment(w4Info[key]).utc().format("MM/DD/YYYY"));
            }
          }
          else {
            this.formData[key] = w4Info[key];
          }
        }
        if (this.formData.MaritalStatus == null)
          this.formData.MaritalStatus = null;

        if (this.fillW4)
          this.formData.SignatureBinary = null;

        if (this.formData.SignatureDate != null &&
          (new Date(parseInt(moment(this.formData.SignatureDate).utc().format("YYYY"))
            , parseInt(moment(this.formData.SignatureDate).utc().format("MM")) - 1
            , parseInt(moment(this.formData.SignatureDate).utc().format("DD")), 0, 0, 0, 0)) < (new Date("2020/01/01"))) {
          this.formData.showNewForm = false;
        }
        else if (
          this.formData.SignatureDate != null
          &&
          (new Date(parseInt(moment(this.formData.SignatureDate).utc().format("YYYY"))
            , parseInt(moment(this.formData.SignatureDate).utc().format("MM")) - 1
            , parseInt(moment(this.formData.SignatureDate).utc().format("DD")), 0, 0, 0, 0)) > (new Date("2020/01/01"))) {
          this.formData.showNewForm = true;
        }
      }
    });
  }

  isExemptUpdated() {
    setTimeout(() => {
      if (this.formData.showNewForm && this.formData.IsExempt) {
        this.formData.MaritalStatus = null;
        this.formData.MultiJobs2020 = null;
        this.formData.QualChildAmount = null;
        this.formData.OtherDependentAmount = null;
        this.formData.DependentAmt2020 = null;
        this.formData.OtherIncome2020 = null;
        this.formData.Deductions2020 = null;
        this.formData.AdditionalAmount = null;
      }
    })
  }

  submit(isAddressInvalid: boolean) {
    isAddressInvalid = typeof (isAddressInvalid) == 'undefined' ? null : isAddressInvalid == true;
    this.hiringService.insertUpdatew4(this.formData).then((response: any) => {
      if (response != null) {
        this.validateCheck = false;
        if (response.success) {
          this.router.navigate(['/careers/tasks']);
        }
      }
    });

  }

  dirty() {
    if (this.formData.DependentAmt2020 || this.formData.OtherIncome2020 || this.formData.Deductions2020 || this.formData.AdditionalAmount)
      this.formData.IsExempt = false;
  }

  step3Calculate() {
    if (this.formData.QualChildAmount != null && this.formData.OtherDependentAmount != null)
      this.formData.DependentAmt2020 = this.formData.QualChildAmount + this.formData.OtherDependentAmount;
  }

  saveW4() {
    this.validateCheck = true;
    if (!this.W4Form.form.invalid) {
      this.alert = null;
      this.hiringService.updateW4ByOnboardIDPart2(this.id, this.formData.EmployerNameAddress, null, this.formData.EIN, this.formData.DateFirstEmployment != null ? moment(this.formData.DateFirstEmployment).format("YYYY-MM-DD") : "").then((response: any) => {
        this.validateCheck = false;
        if (response != null && response.success) {
          this.activeModal.close("success");
        } else {
          this.alert = response.error;
        }
      });
    } else {
      this.alert = "Please fill out all required fields.";
    }
  }

  saveFillW4() {
    this.validateCheck = true;
    this.checkSigned();
    this.checkSSN();

    if (!this.W4Form.form.invalid && ((this.formData.MaritalStatus != null && !this.formData.IsExempt) || (this.formData.IsExempt && this.formData.MaritalStatus == null)) && this.formData.SSN != null) {
      this.alert = null;
      if (this.signatureNEmpty) {
        if (this.formData.SSN != null) {
          this.formData.SSN = this.formData.SSN.split('-').join("");
        }
        if (this.formData.SignDate != null) {
          this.formData.SignDateStr = moment(this.formData.SignDate).utc().format("MM/DD/YYYY");
        }

        if (this.formData.typeSign) {
          this.formData.SignatureBinary = this.rawImgData;
        } else {
          if (this.formData.SignatureBinary == null)
            this.formData.SignatureBinary = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "");
        }

        if (this.longitude != null)
          this.formData.longitude = this.longitude;
        if (this.latitude != null)
          this.formData.latitude = this.latitude;
        for (const [key, val] of Object.entries(this.formData)) {
          if (val == "" && val != 0)
            this.formData[key] = null;
        }

        if (!this.isAddressValidationEnabled) {
          this.submit(true);
          return;
        }

        //------------hold it

        this.validateAddress();
        return;
      } else {
        window.scrollTo(0, 0);
        this.alert = "Please fill out all required fields.";
      }
    } else {
      window.scrollTo(0, 0);
      this.alert = "Please fill out all required fields.";
    }
  }

  validateAddress() {
    this.hiringService.validateAddress(this.formData.Address, this.formData.City, this.formData.State, this.formData.Zip).then((response: any) => {
      if (response != null) {
        if (response.IsValid == false) {
          this.openAddressValidationModal(response.SuggestedAddressString, response.OriginalAddressString, response.SuggestedAddress);
          return;
        }
        else {
          this.submit(true);
        }
      }
      else {
        var address = this.formData.Address + ', ' + this.formData.City + ', ' + this.formData.State + ' ' + this.formData.Zip;
        this.openAddressValidationModal(null, address, null);
      }
    }, (error) => {
      var address = this.formData.Address + ', ' + this.formData.City + ', ' + this.formData.State + ' ' + this.formData.Zip;
      this.openAddressValidationModal(null, address, null);
    });
  }

  openAddressValidationModal(suggestedAddress: string, originalAddress: string, suggestedAddressComponents: any) {
    let modalRef = this.modalService.open(AddressConfirmationModalComponent, { size: 'sm', backdrop: 'static' });
    modalRef.componentInstance.suggestedAddress = suggestedAddress;
    modalRef.componentInstance.badAddress = originalAddress;

    modalRef.result.then((userChoice) => {
      // User chose bad address
      if (userChoice == 0) {
        this.submit(true);
      }
      // User chose suggested address
      else if (userChoice == 1) {
        this.formData.Address = suggestedAddressComponents.Address;
        this.formData.City = suggestedAddressComponents.City;
        this.formData.State = suggestedAddressComponents.State;
        this.formData.Zip = suggestedAddressComponents.PostalCode;
        this.submit(false);
      }
      // User chose to cancel
      else {
        this.utilityService.closeModal();
      } 
    });
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  }

  clickSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.homeService.getTypeSign(type).then((response: any) => {
        this.rawImgData = response;
        this.submitSignImg = "data:image/png;base64," + response;
        this.signatureNEmpty = true;
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  checkSigned() {
    if (this.signaturePad != null) {
      if (!this.signaturePad.isEmpty()) {
        this.redBorder = false;
        this.signatureNEmpty = true;
      }
      else {
        this.redBorder = true;
      }
    }
  }

  clear() {
    if (this.signaturePad != null) {
      if (!this.signaturePad.isEmpty()) {
        this.signaturePad.clear();
      }
      this.signatureNEmpty = false;
    }

    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  base64ArrayBuffer(arrayBuffer: any) {
    var base64 = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes = new Uint8Array(arrayBuffer)
    var byteLength = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
      d = chunk & 63               // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength]

      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4 // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2 // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
  }

  checkSSN() {
    if (this.formData.SSN != null) {
      if (this.formData.SSN.length != 11)
        this.formData.SSN = null;
    }
  }

  updateFormdata(data: string, field: any) {
    this.formData[field] = data;
  }

  closeClick() {
    this.activeModal.close();
  }

  routeToTask() {
    this.router.navigate(['/careers/tasks']);
  }
}
